<div class="buttons-container">
    <button (click)="updateCss()">Submit</button>
    <button routerLink="/management/pdf-template-csses">Back to the list</button>
</div>
<p-toast></p-toast>
<div [formGroup]="cssForm" *ngIf="cssForm">
    <textarea formControlName="body" cols="80" rows="80" class="css-editor"></textarea>
</div>
